import { createSlice } from '@reduxjs/toolkit';
import { setHubspotReady } from '../actions';

export interface HubspotState {
  isHubspotInitialized: boolean;
}

const initialState: HubspotState = {
  isHubspotInitialized: false,
};

const hubspotSlice = createSlice({
  name: 'hubspot',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setHubspotReady, (state) => {
      state.isHubspotInitialized = true;
    });
  },
});

export const hubspotReducer = hubspotSlice.reducer;
